import { apiClient } from "./client";

export const verifyVendorInvite = (token) => {
  const query = new URLSearchParams({ token });
  return apiClient.get(`/vendor/verify?${query.toString()}`, {
    includeToken: false
  });
};

export const registerVendor = (payload) => {
  return apiClient.post("/vendor/register", payload, {
    includeToken: false
  });
};
